class Burger{

    stateClasses = {
        active:"nav--open",
        flyout:"flyout",

    }
    constructor($el){
        this.$el = $el;
        this.$header = $('header');
        this.$html = $('html');
        this.$overlay = $('.overlay');

        this.isOpen = false;
        this.init();
    }

    init = () => {
        this.$el.on('click', this.clickHandler);
        this.$overlay.on('click', this.close);
        
    }

    clickHandler = () => {
        if(this.isOpen){
            this.close()
        }
        else {
            this.open();
        }
    }

    open = () =>{
        this.$header.addClass(this.stateClasses.active);
        this.$html.addClass(this.stateClasses.flyout);
        this.isOpen = true;

    }
    close = () =>{
        this.$header.removeClass(this.stateClasses.active);
        this.$html.removeClass(this.stateClasses.flyout);
        this.isOpen = false;
    }


}

export default Burger;